import { ToolPageShell } from '@/shared/seo'
import { ObrezatPdfForm } from './ObrezatPdfForm'

export function ObrezatPdfPage() {
  return (
    <ToolPageShell utilityKey="crop-pdf">
      <ObrezatPdfForm />
    </ToolPageShell>
  )
}
